import Hidden from "@mui/material/Hidden";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  CardTitle,
  ContentStyle,
  DataGridListStyle,
  ScrollBarStyle,
} from "../../Theme";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useEffect, useState } from "react";
import { RxchangeCount } from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import { v4 as uuid } from "uuid";
import { TextOnly } from "../../components/Content";
import { flushSync } from "react-dom";

const columnsPendingRxChange: GridColDef[] = [
  {
    field: "patientName",
    headerName: "Details",
    width: 150,
    cellClassName: "w25",
    headerClassName: "w25",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "refillCount",
    headerName: "Refill(s)",
    width: 100,
    cellClassName: "w10",
    headerClassName: "w10",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "address",
    headerName: "Address",
    width: 200,
    cellClassName: "w40",
    headerClassName: "w40",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "contactInfo",
    headerName: "Contact",
    width: 100,
    cellClassName: "w15",
    headerClassName: "w15",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
];
export const rowstData = [
  {
    id: 1,
    details: "",
    refills: 0,
    address: "",
    contact: 0,
  },
];

export default function PendingRxChange() {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const primaryDoctor = localStorage.getItem("DoctorName");
  const [isPrinting, setIsPrinting] = useState(false);
  useEffect(() => {
    function handleBeforePrint() {
      flushSync(() => {
        setIsPrinting(true);
      });
    }

    function handleAfterPrint() {
      setIsPrinting(false);
    }

    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);
  let messagePresent;
  if (message === "") {
    messagePresent = (
      <>
        <ScrollBarStyle className="full">
          <Grid container item xs={12} spacing={1} alignItems="top">
            {data?.map((item: any, index: any) => (
              <>
                <Grid item xs={12}>
                  <CardTitle
                    className={
                      primaryDoctor === item?.doctorName
                        ? "primary"
                        : "secondary"
                    }
                  >
                    <Typography component="div" variant="body2">
                      {item?.doctorName}
                    </Typography>
                  </CardTitle>
                </Grid>
                <Grid item xs={12}>
                  {isPrinting ? (
                    <DataGridListStyle
                      className="refills"
                      style={{
                        height: `${item?.rxChangeBodyList?.length * 49}px`,
                      }}
                    >
                      <DataGrid
                        rows={item?.rxChangeBodyList ?? []}
                        headerHeight={0}
                        sortingOrder={["desc", "asc"]}
                        getRowHeight={() => "auto"}
                        columns={columnsPendingRxChange}
                        autoHeight
                        getRowId={(row) => row.patientId ?? uuid()}
                        rowHeight={45}
                        // pageSize={4}
                        // rowsPerPageOptions={[4]}
                        hideFooter={true}
                        disableSelectionOnClick
                        components={{
                          NoRowsOverlay: NoRecords,
                          NoResultsOverlay: NoRecords,
                        }}
                        onRowClick={({ row }) => {
                          navigate(
                            "/pendingrxchangerequest"
                            // , {
                            //   state: {
                            //     rowData: row,
                            //   },
                            // }
                          );
                          sessionStorage.setItem("patientId", row?.patientId);
                          localStorage.setItem(
                            "pendingrxchangerequest-data",
                            JSON.stringify(row)
                          );
                        }}
                      />
                    </DataGridListStyle>
                  ) : (
                    <>
                      <Grid item xs={12} md={12} lg={12}>
                        <Hidden mdDown>
                          <DataGridListStyle className="refills">
                            <DataGrid
                              rows={item?.rxChangeBodyList ?? []}
                              headerHeight={0}
                              sortingOrder={["desc", "asc"]}
                              columns={columnsPendingRxChange}
                              autoHeight
                              getRowId={(row) => row.patientId ?? uuid()}
                              rowHeight={45}
                              // pageSize={4}
                              // rowsPerPageOptions={[4]}
                              hideFooter={true}
                              disableSelectionOnClick
                              components={{
                                NoRowsOverlay: NoRecords,
                                NoResultsOverlay: NoRecords,
                              }}
                              onRowClick={({ row }) => {
                                navigate(
                                  "/pendingrxchangerequest"
                                  // , {
                                  //   state: {
                                  //     rowData: row,
                                  //   },
                                  // }
                                );
                                sessionStorage.setItem(
                                  "patientId",
                                  row?.patientId
                                );
                                localStorage.setItem(
                                  "pendingrxchangerequest-data",
                                  JSON.stringify(row)
                                );
                              }}
                            />
                          </DataGridListStyle>
                        </Hidden>
                        <Hidden mdUp>
                          <DataGridListStyle className="refills">
                            <DataGrid
                              rows={item?.rxChangeBodyList ?? []}
                              headerHeight={36}
                              sortingOrder={["desc", "asc"]}
                              columns={columnsPendingRxChange}
                              autoHeight
                              getRowId={(row) => row.patientId ?? uuid()}
                              rowHeight={60}
                              // pageSize={4}
                              // rowsPerPageOptions={[4]}
                              hideFooter={true}
                              disableSelectionOnClick
                              components={{
                                NoRowsOverlay: NoRecords,
                                NoResultsOverlay: NoRecords,
                              }}
                              onRowClick={({ row }) => {
                                navigate(
                                  "/pendingrxchangerequest"
                                  // , {
                                  //   state: {
                                  //     rowData: row,
                                  //   },
                                  // }
                                );
                                localStorage.setItem(
                                  "pendingrxchangerequest-data",
                                  JSON.stringify(row)
                                );
                              }}
                            />
                          </DataGridListStyle>
                        </Hidden>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            ))}
          </Grid>
        </ScrollBarStyle>
      </>
    );
  } else {
    messagePresent = (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          style={{ height: 200 }}
        >
          <Typography
            fontWeight={"bold"}
            fontStyle={"italic"}
            color={"primary"}
          >
            {message}
          </Typography>
        </Grid>
      </>
    );
  }

  const getRxchangeCount = async () => {
    try {
      const params = new URLSearchParams();
      const doctorId: any = localStorage.getItem("doctorId");
      params.append("doctorId", doctorId);
      params.append("pageNumber", "0");
      const result: any = await RxchangeCount(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response[0]?.items);
      } else {
        setData([]);
        setMessage("No Records Found");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
      setMessage("Try Again After Some Time!");
    }
  };

  useEffect(() => {
    getRxchangeCount();
  }, []);

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Pending Rx Change
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  This section displays the Prescription Change requests
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Grid container item xs={12} spacing={1} alignItems="top">
            <Grid item xs={12}>
              {isPrinting ? (
                <DataGridListStyle className="title">
                  <DataGrid
                    rows={rowstData}
                    headerHeight={36}
                    columns={columnsPendingRxChange}
                    autoHeight
                    rowHeight={40}
                    pageSize={0}
                    rowsPerPageOptions={[0]}
                    hideFooter={true}
                  />
                </DataGridListStyle>
              ) : (
                <Hidden mdDown>
                  <DataGridListStyle className="title">
                    <DataGrid
                      rows={rowstData}
                      headerHeight={36}
                      columns={columnsPendingRxChange}
                      autoHeight
                      rowHeight={40}
                      pageSize={0}
                      rowsPerPageOptions={[0]}
                      hideFooter={true}
                    />
                  </DataGridListStyle>
                </Hidden>
              )}

              {messagePresent}
            </Grid>
          </Grid>
        )}
      </ContentStyle>
    </>
  );
}
